import { CSVProfile, CSVTranformationProfile } from '../../types'
import { MwChartWordCloudChartOptions, SeriesData } from '@meltwater/mw-visualizations-angularjs'

import { BaseVisualization } from '../base/base-visualization-component'
import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import findIndex from 'lodash/findIndex'
export class WordCloudComponent extends BaseVisualization {
 static config = {
  selector: 'wordCloudComponent',
  controller: WordCloudComponent,
  template: `
            <mw-chart-word-cloud
                ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.visualizationData)"
                chart-data="$ctrl.visualizationData"
                chart-options="$ctrl.visualizationOptions"
                get-api="$ctrl.getApi(API)">
            </mw-chart-word-cloud>
        `,
  bindings: BaseVisualization.config.bindings,
 }
 public seriesTitle: string = 'Occurences'
 public seriesColors
 public maxPhraseLength: number = 20

 // default CSV header columns. Can be overriden in sub class.
 public csvHeaders = ['Keyword/Phrase', this.seriesTitle]
 public transformationProfiles: CSVTranformationProfile[] = []

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && !isUndefined(changes.vizData.currentValue)) {
   if (!isEmpty(changes.vizData.currentValue.data)) {
    this.setProperties()
    this.updateData(changes.vizData.currentValue.data)
    this.updateOptions()
    this.buildCSVExportProfile()
   } else {
    this.visualizationData = {}
   }
  }
 }
 setProperties() {}
 updateData(data) {
  this.visualizationData = this.isObjEmpty(data) ? data : this.createNewData(data)
 }

 createNewData(data) {
  return new SeriesData({
   name: this.seriesTitle,
   data: data.all,
  })
 }

 onPointClick = event => {
  this.triggerUpdate(
   this.updatePayload(
    'FILTER_CHANGE',
    'append',
    'subKeyword',
    this.getOriginalTerm(event.key, this.vizData.data.all)
   )
  )
 }

 tooltipFormatter = point => {
  return `${point.key}<br><strong>${this.seriesTitle}:</strong> ${point.value}`
 }

 updateOptions() {
  this.visualizationOptions = new MwChartWordCloudChartOptions({
   seriesColor: this.seriesColors,
   ...(this.isChartClickable() ? { onPointClick: this.onPointClick } : undefined ),
   tooltipFormatter: this.tooltipFormatter,
   maxPhraseLength: this.maxPhraseLength,
  })
 }

 getOriginalTerm(shortenedTerm: string, data: any) {
  let index
  if (shortenedTerm.indexOf('…') > -1) {
   index = findIndex(data, (fullTerm: any) => {
    return fullTerm.key.indexOf(shortenedTerm.replace('…', '')) > -1
   })
   shortenedTerm = data[index].key
  }

  return shortenedTerm
 }

 buildCSVExportProfile() {
  this.csvExportProfiles = []

  let exportData: CSVProfile = {
   data: Object.assign({}, this.vizData.data),
   csvOptions: { title: this.visTitle, headers: this.csvHeaders },
   transformationProfiles: this.transformationProfiles,
  }

  this.csvExportProfiles.push(exportData)
 }
}
